module.exports = __webpack_public_path__ + "img/icon-tipo-legislacao.39a5b112.png";